var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"number-display",class:{ 'nan': _vm.isNaNValue, 'negative': _vm.isNegative, 'isOutOfSpec': _vm.isOutOfSpec }},[_vm._v(" "+_vm._s(_vm.isNaNValue ? 'Err' : _vm.value)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }